import { useState, useContext, useEffect } from "react";
import AuthContext from "../../contexts/auth-context";
 import useAxios from "../../hooks/useAxios";
 import { urls, toastify_status, http_response_messages } from "../../components/config/variables";
 import Toastify from "../../components/ui/Toastify";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";

import './styles.css';

const DoctorSchedule = () => {
  const { operation } = useAxios();
  const authCtx = useContext(AuthContext);
  const token = authCtx?.token || '';
  const [patientList, setPatientList] = useState([]);

  // convert date to UTC ISO timezone string when create or update an event
  const toUTCISOString = (date) => {
  return date.toISOString();
};

  const [events, setEvents] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [open, setOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState({
    id: null,
    title: "",
    patient: "",
    notes: "",
    start: null,
    // end: null,
  });

  const handleDateClick = (info) => {
    const start = new Date(info.date);
    // const end = new Date(start);
    // end.setHours(start.getHours() + 1);

    setCurrentEvent({
      id: null,
      title: "",
      patient: "",
      notes: "",
      start,
      // end,
    });
    setOpen(true);
  };

  const handleEventClick = (clickInfo) => {
    const event = clickInfo.event;
    setCurrentEvent({
      id: parseInt(event.id),
      title: event.title,
      patient: event.extendedProps.patient,
      notes: event.extendedProps.notes,
      start: new Date(event.start),
      // end: new Date(event.end),
    });
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCurrentEvent({ ...currentEvent, [name]: value });
  };

  const handleSave = () => {
    const eventToSave = {
      ...currentEvent,
      scheduled_date: toUTCISOString(currentEvent.start),
      // end: toUTCISOString(currentEvent.end),
    };

    if (!currentEvent.id) {
      handleCreateAppointment(eventToSave)
    } else {
      handleUpdateAppointment(eventToSave)
    }
    setOpen(false);
  };

  const handleEventChange = (changeInfo) => {
    const updatedEvent = {
      id: parseInt(changeInfo.event.id),
      title: changeInfo.event.title,
      patient: changeInfo.event.extendedProps.patient,
      notes: changeInfo.event.extendedProps.notes,
      scheduled_date: toUTCISOString(changeInfo.event.start),
      // end: toUTCISOString(changeInfo.event.end),
    };
    handleUpdateAppointment(updatedEvent)
  };

  const renderEventContent = (eventInfo) => {
    const { title, extendedProps } = eventInfo.event;

    return (
      <div className="event-card">
        <div className="event-header">
          <span className="event-title">{title}</span>
        </div>

        <div className="event-meta">
          {extendedProps.patient_name}
        </div>
      </div>
    );
  };

  const getPatientList = () => {
    operation(
      {
        method: 'GET',
        url: urls.PATIENT_LIST,
        headers: { Authorization: `token ${token}` },
      },
      (res) => {
        setPatientList(res)
      },
      (err) => console.log(err),
    );
  };

  useEffect(() => {
    getPatientList();
    // eslint-disable-next-line
  }, []);

  const handleGetAppointments = () => {
  operation(
    {
      method: 'GET',
      url: urls.LIST_SCHEDULES + `?from_date=${fromDate}&to_date=${toDate}`,
      headers: { Authorization: `token ${token}` },
    },
    (res) => {
      const normalized = res.map(
        ({ scheduled_date, end, ...rest }) => ({
          ...rest,
          start: new Date(scheduled_date), // UTC → local
          // end: new Date(end),               // UTC → local
        })
      );

      setEvents(normalized);
    },
    (err) => console.log(err),
  );
};


  useEffect(() => {
    handleGetAppointments();
    // eslint-disable-next-line
  }, [fromDate, toDate]);

  const handleCreateAppointment = (eventToSave) => {
    operation(
      {
        method: 'POST',
        url: urls.LIST_SCHEDULES,
        headers: { Authorization: `token ${token}` },
        data: eventToSave,
      },
      (res) => {
        Toastify({message: http_response_messages.CREATE_APPOINTMENT, state: toastify_status.SUCCESS})
        const {scheduled_date, ...rest} = res;
        setEvents([
        ...events,
        { ...rest, start: scheduled_date },
      ]);
      },
      (err) => console.log(err),
    );
  }

  const handleUpdateAppointment = (eventToSave) => {
    operation(
      {
        method: 'PATCH',
        url: urls.UPDATE_SCHEDULE.replace(':id', eventToSave.id),
        headers: { Authorization: `token ${token}` },
        data: eventToSave,
      },
      (res) => {
        Toastify({message: http_response_messages.UPDATE_APPOINTMENT, state: toastify_status.SUCCESS})
        const {scheduled_date, ...rest} = res;
        setEvents(events.map((evt) => (evt.id === res.id ? { ...rest, start: scheduled_date } : evt)));
      },
      (err) => console.log(err),
    );
  }

const formatDate = (date) => date.toISOString().slice(0, 10); // yyyy-mm-dd

const handleDatesSet = ({ start, end, view }) => {
  let fromDate;
  let toDate;

  if (view.type === "dayGridMonth") {
    // get month range
    const monthStart = new Date(view.currentStart);
    const monthEnd = new Date(view.currentEnd);
    monthEnd.setDate(monthEnd.getDate() - 1); // end is exclusive

    fromDate = formatDate(monthStart);
    toDate = formatDate(monthEnd);

  } else {
    // get week, day range
    fromDate = formatDate(start);
    const adjustedEnd = new Date(end);
    adjustedEnd.setDate(adjustedEnd.getDate() + 1);

    toDate = formatDate(adjustedEnd);
  }

  setFromDate(fromDate);
  setToDate(toDate);
};

  return (
    <div>
      <FullCalendar
        timeZone="local"
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek" // default view
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay' // Month, Week, Day buttons
        }}
        events={events.map((evt) => ({
          ...evt,
          start: new Date(evt.start),
          end: new Date(evt.end),
        }))}
        dateClick={handleDateClick}
        eventClick={handleEventClick}
        eventContent={renderEventContent}
        editable={true}
        selectable={true}
        nowIndicator={true}
        allDaySlot={false}
        eventDrop={handleEventChange}
        eventResize={handleEventChange}
        height="600px"
        datesSet={handleDatesSet}
      />

      {/* Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {currentEvent.id ? "Edit Appointment" : "Add New Appointment"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Title"
            name="title"
            fullWidth
            value={currentEvent.title}
            onChange={handleChange}
          />
          <TextField
            select
            margin="dense"
            label="Patient"
            name="patient"
            fullWidth
            value={currentEvent.patient}
            onChange={handleChange}
          >
            {patientList.map((patient, index) => (
              <MenuItem key={index} value={patient.id}>
                {patient.patient_name}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            margin="dense"
            label="Notes"
            name="notes"
            fullWidth
            multiline
            rows={3}
            value={currentEvent.notes}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default DoctorSchedule;

/*
Note from Mustafa:
 @fullcalendar/react accept only (start and end) as date objects.
 So when we get data from backend, we need to convert the scheduled_date to start.
 right now we do not have end date from backend.
 And when we create or update an event, we need to convert start to scheduled_date to send to the backend.
*/
